import { Registry } from '../../loader/di/registry.js';
import { selectAdserverGamSettings, selectPositionSettings } from '../../loader/essentials/config-selector.js';
import { CONFIG_RESOLVER } from '../../loader/token.js';
import { GLOBAL_SETTINGS } from '../token.js';

interface AdslotLike {
    slotName: string;
}

interface ConstructAdUnitPathOptions {
    addMcmId?: boolean;
    addDfpZonePostfix?: boolean;
    addNetworkId?: boolean;
}

const SLASH = '/';
const prefixIfValue = (prefix: string, value: string): string => value ? `${prefix}${value}` : '';

export const constructAdUnitPath = ({ slotName }: AdslotLike, { addMcmId = true, addDfpZonePostfix = true, addNetworkId = true, }: ConstructAdUnitPathOptions = {}): string => {
    const globalSettings = Registry.lookup(GLOBAL_SETTINGS);
    const configResolver = Registry.lookup(CONFIG_RESOLVER);

    const { networkId = '4444', mcmId = '', desktopAdUnit = 'unknown', mobileAdUnit = 'unknown', overrides = [] } = configResolver.get(selectAdserverGamSettings())?.config || {};
    const { isMobileSlot = false, dfpZonePostfix = '', dfpPostUnit = '' } = configResolver.get(selectPositionSettings(slotName)) || {};
    const pageType = globalSettings.getPageType();
    const zone = globalSettings.getZone();
    const zoneExtension = globalSettings.getSubZone();


    //prefer overrides when matching adslot is found
    const {
        desktopAdUnit: desktopAdUnitOverride = null,
        mobileAdUnit: mobileAdUnitOverride = null,
        networkId: networkIdOverride = null,
    } = overrides.find(rule => rule.slots.includes(slotName)) || {};

    return [
        prefixIfValue(SLASH, addNetworkId ? networkIdOverride ?? networkId : ''),
        prefixIfValue(',', addNetworkId && addMcmId ? mcmId : ''),
        SLASH,
        isMobileSlot ? mobileAdUnitOverride ?? mobileAdUnit : desktopAdUnitOverride ?? desktopAdUnit,
        SLASH,
        zone,
        prefixIfValue(SLASH, zoneExtension),
        prefixIfValue('_', pageType),
        addDfpZonePostfix ? dfpZonePostfix : '',
        prefixIfValue(SLASH, dfpPostUnit),
    ].join('');
};
